import { Input, Text } from "@fluentui/react-components";
import { AppModal } from "@shared/modal/Modal";
import { sessions } from "@strings/index";
import * as React from "react";
import { useState } from "react";
import { useStyles } from "./OfficeActionNotFoundModal.styles";

const sessionStr = sessions();

type Props = {
  initialApplicationId: string;
  isRetrying: boolean;
  onRetry: (applicationId: string) => Promise<void>;
  onCancel: () => void;
};

export const OfficeActionNotFoundModal: React.FC<Props> = ({
  initialApplicationId,
  isRetrying,
  onRetry,
  onCancel,
}) => {
  const styles = useStyles();
  const [applicationId, setApplicationId] = useState(initialApplicationId);

  const trimmed = applicationId.trim();

  const handleConfirm = async () => {
    if (!trimmed || isRetrying) return;
    await onRetry(trimmed);
  };

  return (
    <AppModal
      open={true}
      title={sessionStr.oaNotFoundTitle}
      content={
        <div className={styles.body}>
          <Text>{sessionStr.oaNotFoundBody}</Text>
          <Input
            size="medium"
            className={styles.field}
            placeholder={sessionStr.oaNotFoundApplicationIdPlaceholder}
            value={applicationId}
            onChange={(_event, data) => setApplicationId(data.value)}
            disabled={isRetrying}
          />
        </div>
      }
      confirmText={sessionStr.oaNotFoundRetry}
      cancelText={sessionStr.oaNotFoundCancel}
      onConfirm={handleConfirm}
      onCancel={onCancel}
      modalType="alert"
      confirmButtonProps={{ disabled: !trimmed || isRetrying }}
    />
  );
};
